import React, { Component } from 'react'
import { createMuiTheme, IconButton, InputAdornment, MuiThemeProvider } from '@material-ui/core'
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers'
import MomentUtils from '@date-io/moment'
import 'moment/locale/sk'
import moment from 'moment'
import CalendarToday from '@material-ui/icons/CalendarToday'
import { inject, observer } from 'mobx-react'


const materialTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      underline: {
        '&::after': {
          borderBottomColor: '#777777',
          borderBottom: '2px solid #777777 !important',
        },
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: '#FF7800',
      },
      thumb: {
        backgroundColor: '#FF7800',
        borderColor: '#FF7800',
      },
    },
    MuiPickersClockNumber: {
      selected: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersDay: {
      day: {
        color: '#777777',
      },
      selected: {
        backgroundColor: '#FF7800',
        '&:hover': {
          backgroundColor: '#FF7800',
        },
      },
      current: {
        color: '#777777',
      },
    },
    MuiPickersYear: {
      root: {
        color: '#777777',
        '&:hover': {
          color: '#FF7800',
        },
      },
      selected: {
        color: '#FF7800 !important',
        '&:hover': {
          color: '#FF7800',
        },
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#777777',
      },
    },
  },
})

@inject('translate')
@observer
export default class CustomDatePicker extends Component {
  render() {
    return <MuiThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils} locale="sk" moment={moment}>
        <div className='date-picker'>
          <DatePicker
            label={this.props.label}
            okLabel={this.props.saveLabel || this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
            cancelLabel={this.props.cancelLabel || this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
            labelFunc={date => date ? date.format('DD.MM.YYYY') : ''}
            minDate={this.props.minDate}
            value={this.props.value}
            onChange={this.props.onChange}
            helperText={this.props.helperText || this.props.errorMessage}
            leftArrowIcon={this.props.leftArrowIcon}
            rightArrowIcon={this.props.rightArrowIcon}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton style={{ padding: 6 }}>
                    <CalendarToday/>
                  </IconButton>
                </InputAdornment>
              ),
            }}
            autoOk={!! this.props.autoOk}
            ampm={!! this.props.ampm}
            showTabs={!! this.props.showTabs}
            clearable={!! this.props.clearable}
            allowKeyboardControl={!! this.props.allowKeyboardControl}
            disableFuture={!! this.props.disableFuture}
            required={!! this.props.required}
            error={!! this.props.hasError}
          />
        </div>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  }
}



// WEBPACK FOOTER //
// ./src/components/basic/DatePicker/DatePicker.jsx